import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';

import {
  GroupSuggestionFragment,
  useUpdateUserSegmentMutation,
  UpdateUserSegmentInput,
  UserSegmentFragment,
  GroupFragment,
} from 'api';
import { GroupPicker } from 'components/Pickers';
import { useUpdateSegment } from 'features/admin/updaters';

interface IProps {
  segment: UserSegmentFragment;
  onSave: () => void;
}

const GroupsEdit: FC<IProps> = ({ segment, onSave }) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<UpdateUserSegmentInput>();

  const [activeGroups, setActiveGroups] = useState(segment.groups);
  const mutationOptions = useUpdateSegment();
  const { mutate: updateUserSegment, isLoading } = useUpdateUserSegmentMutation({
    onSuccess: onSave,
    ...mutationOptions,
  });

  function handleSuggestedGroupsChange(groups: GroupSuggestionFragment[]) {
    // Manage locally to compensate for API
    setActiveGroups(groups as GroupFragment[]);

    updateUserSegment({
      data: {
        ...values,
        group_ids: groups.map(group => group.id),
      },
    });
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Grid container alignItems="center">
          <Grid item>
            <Typography variant="subtitle2">{t('common:group_plural')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={9}>
        <GroupPicker
          selectedGroups={activeGroups}
          onSelectedGroupsChange={handleSuggestedGroupsChange}
          scope="admin"
          excludeIds={segment.group_ids}
          saving={isLoading}
        />
      </Grid>
    </Grid>
  );
};

export default GroupsEdit;
